import axios from "axios";
import { Message } from "element-ui";
import api from "@/config/api";

// 是否正在跳转登录页（防止并发请求重复提示/重复跳转）
let isRedirectingToLogin = false;

// 判断后端返回是否为登录失效类错误
function isAuthError(res) {
    const msg = res?.errMsg || "";
    return /缺少token|登录失效|重新登录|token过期|token 过期|未登录/i.test(msg);
}

// 登录失效统一处理：只提示一次 → 清除登录态 → 跳转登录页
function handleAuthFail(msg) {
    if (isRedirectingToLogin) return;
    isRedirectingToLogin = true;
    Message.error(msg || "登录已过期，请重新登录");
    localStorage.removeItem("molv_token");
    localStorage.removeItem("token_expire_at");
    if (window.location.hash !== "#/login") {
        window.location.hash = "#/login";
    }
    // 到达登录页后复位标记，保证后续正常登录使用
    const onHash = () => {
        if (window.location.hash === "#/login") {
            isRedirectingToLogin = false;
            window.removeEventListener("hashchange", onHash);
        }
    };
    window.addEventListener("hashchange", onHash);
}

// 永不 resolve 的 promise：让页面层的 then/catch 不再执行，避免跳转登录页后仍堆叠报错
const neverResolve = () => new Promise(() => {});

// 创建 axios 实例
const service = axios.create({
    baseURL: api.rootUrl,
    timeout: 10000,
});

// 不需要 token 的接口：与后端公共白名单对齐（/api/pub/* 全部公开 + 后台登录接口）
function isNoAuthUrl(url) {
    return url.includes("/api/pub/") || url.includes("/loginByMobile") || url.includes("/login/byWeb");
}

// 请求拦截
service.interceptors.request.use(
    (config) => {
        if (!isNoAuthUrl(config.url)) {
            const token = localStorage.getItem("molv_token");
            if (!token) {
                // 本地已无登录态：不发请求，直接跳登录页
                handleAuthFail("登录已过期，请重新登录");
                return neverResolve();
            }
            config.headers["molv-token"] = token;
        }

        return config;
    },
    (error) => Promise.reject(error)
);

// 响应拦截
service.interceptors.response.use(
    (response) => {
        const res = response.data;

        if (res.errCode !== 0) {
            // 登录失效：统一跳登录页，不再由页面逐个弹错
            if (isAuthError(res)) {
                handleAuthFail(res.errMsg);
                return neverResolve();
            }

            Message.error(res.errMsg || "请求失败");
            return Promise.reject(res);
        }
        return res;
    },
    (error) => {
        // HTTP 401/403 同样视为登录失效
        const status = error?.response?.status;
        if (status === 401 || status === 403) {
            handleAuthFail("登录已过期，请重新登录");
            return neverResolve();
        }

        // 正常错误提示
        Message.error(
            error?.response?.data?.errMsg ||
            error?.response?.data?.message ||
            error.message ||
            "请求失败"
        );
        return Promise.reject(error);
    }
);

export default service;
